import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import { isMultiplePayments } from '../../../states/payments/selectors';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import confirmedContent, { contentPropTypes } from './confirmed.content';
import { isBatch } from '../../../states/batch/selectors';
import ConfirmedPayments from './ConfirmedPayments';
import ConfirmedBatch from './ConfirmedBatch';
import { getUserId } from '../../../states/user/selectors';

const mapState = (state) => ({
	isMultiplePayments: isMultiplePayments(state),
	isBatch: isBatch(state),
	userId: getUserId(state),
});

class Confirmed extends Component {
	componentDidMount() {
		this.props.handleComplete();
	}

	render() {
		const { isMultiplePayments, isBatch, content, handleRoute, handleReset, userId } = this.props;
		const subHeader = isMultiplePayments ? content.subHeader : content.singlePaymentSubHeader;

		const renderPayments = () => {
			if (isBatch) {
				return <ConfirmedBatch userId={userId} handleRoute={handleRoute} />;
			}
			return <ConfirmedPayments handleRoute={handleRoute} userId={userId} />;
		};

		return (
			<div>
				<PageHeading isFlush data-test-id="confirmed-page">
					{content.header}
				</PageHeading>
				{subHeader && <p className="u-margin-top-1">{subHeader}</p>}
				{renderPayments()}
				<div className="u-margin-top-2">
					<ButtonGroup>
						<Button display="secondary" className="u-margin-right-1" onClick={() => handleRoute('WEB-HOMEPAGE')}>
							{content.accountsButtonLabel}
						</Button>
						<Button
							id="makeAnotherPaymentButton"
							display="secondary"
							className="u-margin-right-1"
							onClick={handleReset}
						>
							{content.anotherPaymentButtonLabel}
						</Button>
						<Button display="secondary" onClick={() => handleRoute('WEB-MANAGE-PAYMENT-STATUS')}>
							{content.paymentStatusButtonLabel}
						</Button>
					</ButtonGroup>
				</div>
			</div>
		);
	}
}

Confirmed.defaultProps = {
	handleComplete: () => {},
};

Confirmed.propTypes = {
	isMultiplePayments: PropTypes.bool.isRequired,
	userId: PropTypes.string.isRequired,
	isBatch: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes),
	handleRoute: PropTypes.func.isRequired,
	handleReset: PropTypes.func.isRequired,
	handleComplete: PropTypes.func,
};

const contentWrapper = withContent({ content: confirmedContent });
export default connect(mapState)(withScrollTop(contentWrapper(Confirmed)));
export const ConnectWrapper = connect(mapState)(Confirmed);
